import config from 'config';
import * as types from '../actions/game-actions';

const initialState = {
	currentQuestion: {},
	isCorrect: null,
	wonNewTicket: false,
	questionsAvailable: 0,
	crossSelling: { claroMusica: null, comboHits: null },
	currentStep: config.constants.gameSteps.waitingAnswer
};

const userReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.RESET_GAME:
		return Object.assign({}, state, initialState);
		break;

		case types.GET_GAME:
			return Object.assign({}, state, action.game, {
				isCorrect: null,
				currentStep: config.constants.gameSteps.waitingAnswer
			});
			break;

		case types.ANSWER_REVISION:
			return Object.assign({}, state, {
				isCorrect: action.isCorrect,
				currentStep: config.constants.gameSteps.answerRevision
			});
			break;
	}

	return state;
};

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/game-reducer.js